import reducer, * as selectors from './reducer';
import RootView from './components/root_view';

export const SomnReducer = reducer;
export const SomnSelectors = selectors;

const Somn = RootView;
export default Somn;
